import { render, staticRenderFns } from "./TransactionDeposit.vue?vue&type=template&id=f5d2162e&"
import script from "./TransactionDeposit.vue?vue&type=script&lang=ts&"
export * from "./TransactionDeposit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports